import translations from "../../translate";
import "./about-section.styles.css";

const AboutSection = ({ language }) => {
  const aboutText = translations[language]?.aboutSection?.text || ""; // بررسی زبان در هر رندر

  return (
    <div className="about-section">
      <div className="container">
        <div className="about-section-content">
          <h2 className="about-section-title-text"></h2>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
